export const taiwanese = {
  translation: {
    // ================================= titles =================================
    titles: {
      popular_add_ons: '受歡迎搭配',
      top: '頂部',
      hello: '您好',
      in_your_cart: '在您的購物車',
      search_result: '搜尋結果',
      no_items_found: '找到 0 件商品',
      search_empty: '沒有結果可顯示',
      call_staff: '我們收到您的來電',
      sub_total: '小計',
      total: '總計l',
      order_details: '訂單細節',
      order_history: '訂單歷史',
      popup_pay: '您準備好要結帳嗎？',
      payment_success: '我們收到您需求付款',
      order_empty: '您的訂單是空的',
      pending: '待處理',
      served: '已確認',
      confirmed: '已確認',
      finish_cooking: '完成烹飪',
      cancelled: '已取消',
      ready_to_order: '準備好點餐嗎？',
      order_success: '我們收到您的訂單',
      maxQuantityPerOrder: '最多. 數量/訂單',
      topping_type_quantity: '最少 {{min}} - 最多 {{max}}',
      menu_excludes_vat: '價錢不包含VAT稅.',
      rescanQR: '掃描QR代碼再下單一次.',
      choose_language_to_start: '現在選擇您的語言',
      extraFee: '額外費用',
      discountAmount: '折扣',
      customizedService: '給您的客製化服務',
      selectOption: '請選擇一個選項',
      call_staff_reasons: '聯絡員工',
      choose_payment_method: '選擇付款方式',
      payment_successfully: '付款成功',
      payment_failed: '付款失敗',
      how_was_your_experience: '您的體驗如何',
      your_details: '您的詳情',
      how_many_people: '你們有多少人？',
      please_select_number_of_people: '*請選擇包括嬰兒在內的人數。',
      choose_number_of_people: '請選擇您今天用餐人數:',
      buffet: '自助餐',
      order_placed: '已下訂單!',
      order_code: '訂單代碼',
      review_order: '請在這也給我們評論',
      popular: '熱銷',
      hope_you_enjoyed: '希望您喜歡.',
      review_success: '非常感謝您!',
      popup_food_error_order:
        '這餐點 <span style="font-weight:{{fontWeight}}">{{nameFood}}</span> 售完!',
      popup_topping_error_order:
        '配菜  <span style="font-weight:{{fontWeight}}">{{nameTopping}}</span> 售完!',
      discount: '折扣',
      input_a_name: '輸入電話',
      input_a_phone: '輸入電話',
      why_we_need_it: '為什麼我們需要它？',
      // tablet
      search: '搜尋',
      call_staff_tablet: '呼叫服務員',
      bill: '帳單',
      pay: '付款',
      table_number: '桌號：',
      ask_for_bill: '索取帳單',
      ask_for_bill_decription: '點擊“索取帳單”，我們會為您帶來帳單。',
      not_yet: '尚未',
      quantity: '數量',
      item_table: '商品',
      status_table: '狀態',
      price_table: '價格',
      other: '其他',
    },
    // ================================= descriptions =================================
    descriptions: {
      reached_end: '您要到達終點',
      cart_empty: '您的購物車是空的',
      hint_cart_empty: '點擊這裡看菜單',
      search_empty: '請確認拼音或是其他關鍵字',
      call_staff: '我們將盡快為您服務，感謝您的耐心等待',
      popup_pay: '點擊“付款請求”，以便我們將帳單送到您的餐桌上',
      payment_success: '我們將儘快為您服務，感謝您的耐心等待',
      restaurant_on_capichi:
        '如果您想在家中有一樣的體驗, 請找我們在 <span style="color:{{colorText}}">Capichi 配送</span>',
      order_empty: '開始您的點餐從添加您想要的餐點',
      orderNotFound: '沒有找到訂單!',
      order_success: '我們將盡快處理您的訂單，感謝您的耐心.',
      rescanQR: '非常抱歉，您的訂單已經確認。需要再重新掃描QR代碼才可在該餐廳開始點餐.',
      order_food_and_drink: '任何時間訂購您想要的食物和飲料',
      seek_for_help: '直接從線上員工尋求幫助',
      ask_to_pay: '當您用餐完畢可詢問付款',
      or_ask_directly: '或是直接找員工',
      haveVAT: 'VAT税 {{vatRate}}% 不包含',
      haveServiceFee: '我們有服務費{{serviceRate}}%',
      popup_payment_success:
        '您的線上付款已確認。感謝您今天選擇使用我們並希望您擁有美好的時光和體驗.',
      popup_payment_failed: '由於異常，付款失敗。請稍後重試或使用其他付款方式.',
      tap_to_save_screen: '請出示這個螢幕給店裡的員工',
      checkouted_order: `感謝您今天選擇我們來訂餐，我們誠心希望您喜歡與我們一起的時光。
      我們非常感激如果您願意在以下分享您的體驗將成為我們成長與餐廳的進步.`,
      review_success: '“您的評論已收到，我們將在下一步學習中考慮它。您真的很有幫助 !',
      input_a_name:
        '您目前正在從包含不同訂單的表格中訂購，為了確保我們正確拆分訂單，請輸入簡單的名稱*來識別您的訂單。',
      input_a_phone: '我們需要您的電話號碼，當您成功下單後以利傳送簡訊追蹤訂單。',
      min_left: '{{min_left}}分鐘內您可以在菜單內吃到飽.',
    },
    // ================================= actions ==================================
    actions: {
      call_staff: '尋求工作人員的幫助',
      pay: '付款',
      back_to_top: '回到上面',
      order: '點餐',
      go_back: '返回',
      see_menu: '查看菜單',
      order_now: '立即點餐',
      clear_all: '全部清除',
      search_again: '再次搜尋',
      retry: '重試',
      back_to_menu: '回到菜單',
      ask_for_bill: '需求付款',
      not_yet: '尚未',
      discover: '發現',
      delete_dish: '刪除',
      noteFood: '點擊添加個人需求',
      addToCart: '添加到購物車',
      addNote: '添加備註',
      confirmOrder: '確認',
      start_ordering: '開始點餐',
      pay_online: '線上付款',
      send: '提交',
      try_again: '再試一次',
      call_staff_for_help: '請求員工幫忙',
      skip: '跳過',
      next: '下一步',
      done: '完成',
      confirm: '確認',
      order_from_here: '從這裡點餐',
      tap_to_save_screen: '點擊儲存螢幕',
      see_a_menu: '查看菜單',
      update: '更新',
      cancel: '取消',
      add: '添加',
      ok: '好的',
      see_the_time: '查看時間',
    },
    // ================================= errors =================================
    errors: {
      server_error: '抱歉，很遺憾無法訪問伺服器',
      errorOutOfStock: '抱歉，這個品項已售完，請下單其他品項.',
      errorQuantityPerOrder: '您所選的餐點數量已超過最大數量。請重新選擇.',
      errorQuantityExceeded: '抱歉，這個品項的需求數量現在不可用的。請更改此品項數量。.',
      somethingWrong: '出現錯誤，請再試一次!',
      errorFoodHasChanged: '抱歉，此餐廳剛更新資訊，請重置購物車.',
      warningMin: '請最小訂購 {{min}} 個配菜',
      warningMax: '請最多訂購 {{max}} 個配菜',
      notFoundFoodItem: '抱歉，餐廳暫時不提供此餐點，請稍候再試.',
      errorNotOpenTable: `您的桌子尚未開始營業。請洽員工協助.`,
      max_comment_review: '最多 {{max}} 個字',
      payment_method_changed: '已變更付款方式.',
      payment_method_changed_desc: '請刷新網頁後再次選擇您的付款方式.',
      max_characters: '最多 {{max}} 的字',
      required_floor: '請輸入您的樓層',
      required_room: '請輸入您的房號.',
      required_full_name: '請輸入您的完整姓名',
      errorOutOfStockNEC: '沒有庫存',
      rating_already_existed: '抱歉，此訂單已評論過',
      voucher_not_suitable: '此優惠卷不適用。請再試一次',
      error: '錯誤',
      voucher_not_found: '優惠碼不存在。請使用別的代碼。',
      voucher_outside_time_period: '優惠碼無效或是已過期。請使用別的代碼。',
      voucher_just_apply_for_restaurants: '此優惠卷只適用{{restaurants}}',
      voucher_min_order_value: '優惠碼適用訂單滿{{min_order_value}}',
      voucher_has_been_used: '優惠碼已被使用',
      voucher_out_of_quantity: '此優惠碼已過期。請嘗試另外的代碼。',
      min_max_phone_number: '請輸入手機號碼{{min}}-{{max}}個數字之間',
    },
    // ================================= languages =================================
    languages: {},
    // ================================= label =================================
    label: {
      zezoYen: '0 yen',
      required: '需求',
      optional: '任選',
      my_cart: '我的購物車',
      items_found: '已找到品項',
      sold_out: '售完',
      items: '品項',
      powered_by: '提供於',
      vat: 'VAT税',
      service_fee: '服務費',
      your_order: '您的訂單',
      or: '或',
      payment_methods: {
        international_card: '信用卡',
        atm: 'ATM轉帳',
        qr_code: 'QR 代碼轉帳',
        e_wallet: '電子錢包',
      },
      review_or_comment: '留給我們回饋和評語',
      buffet: '自助餐',
      min_left: '限時<strong style="color:{{color}}">{{min_left}}</strong>分鐘',
      all_you_can_drink: '皆可飲食',
    },
    // ================================= placeholder =================================
    placeholder: {
      input_search: '搜尋餐點、菜單、飲品…',
      choose_your_floor: '選擇您的樓層',
      choose_your_room: '選擇您的房間',
      your_full_name: '您的全名',
      no_results: '沒有結果',
      enter_voucher_code: '輸入優惠代碼',
      your_name: '你的名字',
      your_phone: '您的電話',
    },
    popup_start_buffet: {
      course_menu_has_started: '套餐菜單已上線。',
      time_limit: '時間限制',
      time_value: '{{value}}分鐘',
      see_menu: '查看菜單',
    },
    popup_add_friend_line: {
      line: 'LINE',
      description: '请将我们加为 LINE 好友以使用手机订餐服务。',
      add_friend_btn: '加为 LINE 好友',
      already_added: '已添加为好友',
    },
  },
}
